export default "__VITE_ASSET__d162c3e9__"